import { create } from "zustand";
import {
  getOvertimeRequests,
  getMyOvertimeRequests,
  approveOvertimeRequest,
  rejectOvertimeRequest,
  cancelOvertimeRequest,
  deleteOvertimeRequest,
  createOvertimeRequest,
} from "api/attendance";
import { getOvertimeHistory } from "api/attendance";
import { isEqual } from "lodash";

const useOvertimeStore = create((set, get) => ({
  /* ================= STATE ================= */
  overtimeRequests: [],
  loading: false,
  error: null,
  actionLoading: null,

  /* 🔹 FILTERS (SOURCE OF TRUTH) */
  filters: {
    status: "",
    from: "",
    to: "",
    q: "",
    page: 1,
    per_page: 10,
  },

  /* 🔹 PAGINATION */
  pagination: {
    total: 0,
    last_page: 1,
    current_page: 1,
    per_page: 10,
  },

  /* ================= HELPERS ================= */
  setFilters: (newFilters) =>
    set((state) => ({
      filters: {
        ...state.filters,
        ...newFilters,
      },
    })),

  resetFilters: () =>
    set({
      filters: {
        status: "",
        from: "",
        to: "",
        q: "",
        page: 1,
        per_page: 10,
      },
    }),

  /* ================= CREATE ================= */
  addOvertimeRequest: async (payload) => {
    set({ actionLoading: true, error: null });
    try {
      const res = await createOvertimeRequest(payload);

      const newRequest = res?.data?.data || res?.data;

      set((state) => ({
        overtimeRequests: newRequest
          ? [newRequest, ...state.overtimeRequests]
          : state.overtimeRequests,
        actionLoading: null,
      }));

      return { success: true, data: res.data };
    } catch (err) {
      set({ error: err.message, actionLoading: null });
      return { success: false };
    }
  },

  /* ================= FETCH (ADMIN / MANAGER) ================= */

  // fetchOvertimeRequests: async (params = {}) => {
  //   set({ loading: true, error: null });

  //   try {
  //     const stateFilters = get().filters;

  //     const finalParams = {
  //       ...stateFilters,
  //       ...params,
  //       status: params.hasOwnProperty("status") ? params.status : "",
  //     };

  //     const res = await getOvertimeRequests(finalParams);

  //     const data = res?.requests?.data || res?.data?.data || res?.data || [];

  //     set({
  //       overtimeRequests: data,
  //       pagination: {
  //         total: res?.meta?.total || 0,
  //         last_page: res?.meta?.last_page || 1,
  //         current_page: res?.meta?.current_page || 1,
  //         per_page: res?.meta?.per_page || finalParams.per_page,
  //       },
  //       loading: false,
  //     });

  //     return res;
  //   } catch (err) {
  //     set({ error: err.message, loading: false });
  //     throw err;
  //   }
  // },

  fetchOvertimeRequests: async (params = {}) => {
    set({ loading: true, error: null });

    try {
      const stateFilters = get().filters;
      const finalParams = {
        ...stateFilters,
        ...params,
        status: params.hasOwnProperty("status") ? params.status : "",
      };

      const res = await getOvertimeRequests(finalParams);
      const data = res?.requests?.data || res?.data?.data || res?.data || [];
      const newPagination = {
        total: res?.meta?.total || 0,
        last_page: res?.meta?.last_page || 1,
        current_page: res?.meta?.current_page || 1,
        per_page: res?.meta?.per_page || finalParams.per_page,
      };

      const currentState = get();
      const dataChanged = !isEqual(currentState.overtimeRequests, data);
      const paginationChanged = !isEqual(currentState.pagination, newPagination);

      if (dataChanged || paginationChanged) {
        set({
          overtimeRequests: data,
          pagination: newPagination,
          loading: false,
        });
      } else {
        set({ loading: false });
      }

      return res;
    } catch (err) {
      set({ error: err.message, loading: false });
      throw err;
    }
  },


  // fetchOvertimeHistory: async (params = {}) => {
  //   set({ loading: true, error: null });

  //   try {
  //     const stateFilters = get().filters;

  //     const finalParams = {
  //       ...stateFilters,
  //       ...params,
  //       status: params.hasOwnProperty("status") ? params.status : "",
  //     };

  //     const res = await getOvertimeHistory(finalParams);
  //     const data = res?.data?.data || res?.data || [];

  //     set({
  //       overtimeRequests: data,
  //       pagination: {
  //         total: res?.meta?.total || 0,
  //         last_page: res?.meta?.last_page || 1,
  //         current_page: res?.meta?.current_page || 1,
  //         per_page: res?.meta?.per_page || finalParams.per_page,
  //       },
  //       loading: false,
  //     });

  //     return res;
  //   } catch (err) {
  //     set({ error: err.message, loading: false });
  //     throw err;
  //   }
  // },

  fetchOvertimeHistory: async (params = {}) => {
    set({ loading: true, error: null });

    try {
      const stateFilters = get().filters;
      const finalParams = {
        ...stateFilters,
        ...params,
        status: params.hasOwnProperty("status") ? params.status : "",
      };

      const res = await getOvertimeHistory(finalParams);
      const data = res?.data?.data || res?.data || [];
      const newPagination = {
        total: res?.meta?.total || 0,
        last_page: res?.meta?.last_page || 1,
        current_page: res?.meta?.current_page || 1,
        per_page: res?.meta?.per_page || finalParams.per_page,
      };

      const currentState = get();
      const dataChanged = !isEqual(currentState.overtimeRequests, data);
      const paginationChanged = !isEqual(currentState.pagination, newPagination);

      if (dataChanged || paginationChanged) {
        set({
          overtimeRequests: data,
          pagination: newPagination,
          loading: false,
        });
      } else {
        set({ loading: false });
      }

      return res;
    } catch (err) {
      set({ error: err.message, loading: false });
      throw err;
    }
  },


  /* ================= FETCH (MY OVERTIME) ✅ FIXED ================= */
  // fetchMyOvertimeRequests: async (params = {}) => {
  //   set({ loading: true, error: null });

  //   try {
  //     /* 🔹 MERGE FILTERS */
  //     const finalParams = {
  //       ...get().filters,
  //       ...params,
  //     };

  //     // set({ filters: finalParams });

  //     /* 🔹 API CALL WITH FILTERS */
  //     const res = await getMyOvertimeRequests(finalParams);
  //     const data = res?.data?.data || res?.data || [];

  //     set({
  //       overtimeRequests: data,
  //       pagination: {
  //         total: res?.meta?.total || 0,
  //         last_page: res?.meta?.last_page || 1,
  //         current_page: res?.meta?.current_page || finalParams.page,
  //         per_page: res?.meta?.per_page || finalParams.per_page,
  //       },
  //       loading: false,
  //     });
  //   } catch (err) {
  //     set({ error: err.message, loading: false });
  //   }
  // },

  fetchMyOvertimeRequests: async (params = {}) => {
    set({ loading: true, error: null });

    try {
      const finalParams = {
        ...get().filters,
        ...params,
      };

      const res = await getMyOvertimeRequests(finalParams);
      const data = res?.data?.data || res?.data || [];
      const newPagination = {
        total: res?.meta?.total || 0,
        last_page: res?.meta?.last_page || 1,
        current_page: res?.meta?.current_page || finalParams.page,
        per_page: res?.meta?.per_page || finalParams.per_page,
      };

      const currentState = get();
      const dataChanged = !isEqual(currentState.overtimeRequests, data);
      const paginationChanged = !isEqual(currentState.pagination, newPagination);

      if (dataChanged || paginationChanged) {
        set({
          overtimeRequests: data,
          pagination: newPagination,
          loading: false,
        });
      } else {
        set({ loading: false });
      }
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  /* ================= APPROVE ================= */
  approveRequest: async (id, reason = "") => {
    set({ actionLoading: id, error: null });
    try {
      await approveOvertimeRequest(id, reason);

      set((state) => ({
        overtimeRequests: state.overtimeRequests.map((r) =>
          r.id === id
            ? {
              ...r,
              status: "approved",
              status_reason: reason,
              updated_at: new Date().toISOString(),
            }
            : r
        ),
        actionLoading: null,
      }));

      return { success: true };
    } catch (err) {
      set({ error: err.message, actionLoading: null });
      return { success: false };
    }
  },

  /* ================= REJECT ================= */
  rejectRequest: async (id, reason = "") => {
    set({ actionLoading: id, error: null });
    try {
      await rejectOvertimeRequest(id, reason);

      set((state) => ({
        overtimeRequests: state.overtimeRequests.map((r) =>
          r.id === id
            ? {
              ...r,
              status: "rejected",
              status_reason: reason,
              updated_at: new Date().toISOString(),
            }
            : r
        ),
        actionLoading: null,
      }));

      return { success: true };
    } catch (err) {
      set({ error: err.message, actionLoading: null });
      return { success: false };
    }
  },

  /* ================= CANCEL ================= */
  cancelRequest: async (id, reason = "") => {
    set({ actionLoading: id, error: null });
    try {
      const res = await cancelOvertimeRequest(id, {
        cancel_reason: reason,
      });

      set((state) => ({
        overtimeRequests: state.overtimeRequests.map((r) =>
          r.id === id
            ? {
              ...r,
              status: "cancelled",
              status_reason: reason,
              updated_at: res?.data?.updated_at || new Date().toISOString(),
            }
            : r
        ),
        actionLoading: null,
      }));

      return { success: true };
    } catch (err) {
      set({ error: err.message, actionLoading: null });
      return { success: false };
    }
  },

  /* ================= DELETE ================= */
  deleteRequest: async (id) => {
    set({ actionLoading: id, error: null });
    try {
      await deleteOvertimeRequest(id);

      set((state) => ({
        overtimeRequests: state.overtimeRequests.filter((r) => r.id !== id),
        actionLoading: null,
      }));

      return { success: true };
    } catch (err) {
      set({ error: err.message, actionLoading: null });
      return { success: false };
    }
  },

  /* ================= RESET ================= */
  resetOvertimeStore: () =>
    set({
      overtimeRequests: [],
      loading: false,
      error: null,
      actionLoading: null,
      filters: {
        status: "",
        from: "",
        to: "",
        q: "",
        page: 1,
        per_page: 10,
      },
      pagination: {
        total: 0,
        last_page: 1,
        current_page: 1,
        per_page: 10,
      },
    }),
}));

export default useOvertimeStore;
